import React from "react";
import { Link } from "react-router-dom";
import parseNumber from "../../../../utils/parseCalculate";
import { Tooltip } from "@mui/material";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";
import { BatteryIcon, DeleteIcon, EditIcon, WifiIcon } from "../../../icons/StatusIcons";

const DeviceCard = (props) => {
  const convertFormat = (utcDateTimeStr) => {
    const utcDateTime = new Date(utcDateTimeStr);

    // Convert to Indian Standard Time (IST)
    const localDateTime = new Date(
      utcDateTime.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );

    // Format the local date and time
    const day = String(localDateTime.getUTCDate()).padStart(2, "0");
    const month = String(localDateTime.getUTCMonth() + 1).padStart(2, "0");
    const year = localDateTime.getUTCFullYear();
    const hours = String(localDateTime.getUTCHours()).padStart(2, "0");
    const minutes = String(localDateTime.getUTCMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const { data: liveData } = useLiveDevice(props.deviceId);
  const deviceDetail = liveData || props.deviceDetail || {};
  const localDateStr = deviceDetail?.date_time ? convertFormat(deviceDetail.date_time) : "--";

  return (
    <div className={`detail-listing-wrap ${props.className || ""}`.trim()}>
      <div className="listing-detail-wrap">
        <div className="about-info-wrap">
          <Link to={props.link} className="user-name text-uppercase">
            {props.name}
          </Link>
          {props.company && <p className="user-company">{props.company}</p>}
        </div>
        {!props.assignee ? (
          <p className="empty-text w-50 text-center">Device Not Assigned</p>
        ) : (
          <>
            <div className="flow-info">
              <h5 className="assigned-num">{parseNumber(deviceDetail?.flowrate || deviceDetail?.level)}</h5>
              <p className="assigned-text">
                {props.deviceType === "flow" ? "Current Flow" : "Current Level"}
              </p>
              <p className="flow-unit">{props.unit}</p>
            </div>
            {props.deviceType === "flow" && (
              <div className="total-flow-info">
                <h5 className="assigned-num">{parseNumber(deviceDetail?.totalizer)}</h5>
                <p className="assigned-text">Total Flow</p>
                <p className="flow-unit">{props.totalUnit}</p>
              </div>
            )}
            {!props.hideDates && (
              <div className="user-dates">
                <p className="user-data-text">
                  Subscription End: <span> {props.endDate} </span>
                </p>
                <p className="user-data-text">
                  Last Updated:{" "}
                  <span className="text-danger">
                    {" "}
                    {localDateStr}{" "}
                  </span>
                </p>
              </div>
            )}
          </>
        )}
      </div>

      <div className="card-actions">
        {!props.assignee ? (
          <button onClick={props.onAssign} className="empty-text">
            Assign
          </button>
        ) : (
          <>
            {!props.hideUpdate && (
              <button
                type="button"
                onClick={props.onUpdate}
                className="btn-action"
                aria-label="Edit device"
              >
                <EditIcon />
              </button>
            )}
          </>
        )}

        {!props.deleteHide && (
          <button
            type="button"
            onClick={props.onDelete}
            className="btn-action"
            aria-label="Delete device"
          >
            <DeleteIcon />
          </button>
        )}

        <div className="btn-action">
          <WifiIcon connected={deviceDetail?.network_active === 1} />
        </div>
        <Tooltip title={deviceDetail?.battery === 1 ? "Power On" : "Power Off"}>
          <BatteryIcon on={deviceDetail?.battery === 1} />
        </Tooltip>
      </div>
    </div>
  );
};

export default DeviceCard;
